import Button from './Button';
const ConfirmDialog = ({ title, message, onConfirm, onCancel, loading, confirmLabel = 'Confirm', variant = 'danger' }) => (
  <div className="fixed inset-0 z-[100]">
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm animate-fade-in" onClick={onCancel} />
    <div className="fixed inset-0 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-5 w-full max-w-sm shadow-xl animate-scale-in">
        <h3 className="text-lg font-bold text-pw-text">{title}</h3>
        <p className="text-pw-text-variant mt-2 text-sm">{message}</p>
        <div className="flex gap-3 mt-6">
          <Button variant="secondary" onClick={onCancel} className="flex-1">Cancel</Button>
          <Button variant={variant} onClick={onConfirm} loading={loading} className="flex-1">{confirmLabel}</Button>
        </div>
      </div>
    </div>
  </div>
);
export default ConfirmDialog;
